<template>
    <ly-auto-input
        :placeholder="placeholder"
        icon="information"
        :width="width"
        :size="json.size"
        :fetch-suggestions="fetchSuggestions"
        :dropdown-width="dropdownWidth"
        :dropdown-fields="json.fields"
        :is-init-search="isInitSearch"
        v-model="value[json.prop]"
        @keydown.up.native.prevent="keydownFn"
        @keydown.down.native.prevent="keydownFn"
        @change="autoChange">
    </ly-auto-input>
</template>
<script>
    /**
     * 带搜索的信息输入组件
     * @author zjs
     * @time 2017-09-12
     */
    import LyAutoInput from '@c/autoinput'
    export default {
        name: 'LyAutoSymptom',
        components: {
            LyAutoInput
        },
        props: {
            // value是一个customer对象
            value: {
                typte: Object,
                default: () => {}
            },
            /**
                客户信息 相关的配置
                json 示例：
                {
                    prop: 'customer_name'  
                    isWatchOther: false // 标识是否监听other的变化，为true则other变化后自动搜索
                } // prop 指定要绑定对象中哪个字段的值
             */
            json: Object,
            // 组件的宽度
            width: {
                type: String,
                default: '220px'
            },
            // 结果列表面板的宽度
            dropdownWidth: {
                type: String,
                default: '300px'
            },
            placeholder: {
                type: String,
                default: '请输入'
            },
            isInitSearch: { // 标识是否初始就进行数据的获取
                type: Boolean, 
                default: false
            },
            other: {
                typte: Object,
                default: () => {}
            } // 额外提交查询的的对象数据
        },
        data () {
            return {
                dataCount: 0 // 记录当前数据列表的数据长度
            }
        },
        watch: {
            other (val) {
                if (this.json && this.json.isWatchOther) {
                    this.other['type'] = 1 // 客户选择是标识是客户这边带动走开票接口的  wxq  2018.8.30
                    this.fetchSuggestions('', (rs) => {
                        if (rs.length > 0) {
                            this.$emit('input', rs[0])
                        }
                        delete this.other.type // 删除type这个标识客户带动搜索的字段
                    })
                }
            }
        },
        methods: {
            /**
             * 2019-09-06添加，
             * 监听输入框的上下键，在外层也能监听，这里是监听后获得查询出来的数据长度
             * 如果有数据，上下键是用来选择数据的，而不是用来跨行
             */
            keydownFn () {
                this.$emit('count', this.dataCount)
            },
            /**
             * 数据的查找
             * @param {[String]} keyword [查询的关键字]
             * @param {[Function]} callback [查询后的回调]
             */
            fetchSuggestions (keyword, callback) {
                let data = {}
                if (this.other) {
                    data = Object.assign(data, this.other)
                }
                data[this.json.prop] = keyword
                this.$api.query(this.json.api, data).then((rs) => {
                    this.dataCount = rs.length || 0
                    callback(rs)
                }).catch((err) => {
                    callback([])
                    console.error('auto-search query error:%O', err)
                })
                // this.$api.product.query({keyword: keyword}).then((rs) => {
                //     callback(rs)
                // })
            },
            /**
             * 选中的数据
             * @param  {[type]} row [description]
             * @return {[type]}     [description]
             */
            autoChange (row) {
                if (row !== this.value) {
                    this.$emit('input', row)
                }
            }
        }
    }
</script>